import React from 'react';
import classNames from 'classnames';
import Partners from '../../pages/my-projects/Project/Header-new/Partners';
import Site from '../../pages/my-projects/Project/Header-new/Site';
import DateRange from '../../pages/my-projects/Project/Header-new/DateRange';
import Creator from '../../pages/my-projects/Project/Header-new/Creator';
import Title from '../../pages/my-projects/Project/Header-new/Title';
import StatusTags from '../../pages/my-projects/Project/Header-new/StatusTags';
import Description from '../../pages/my-projects/Project/Header-new/Description';
import Distance from '../../pages/projects/Project/Distance';

export default function ComposableProjectHeader(props) {
  const {
    project,
    tags,
    onClick,
    showTags = true,
    showTitle = true,
    showDescription = true,
    showDateRange = true,
    showCreator = true,
    showSite = true,
    showPartners = true,
    showDistance = false
  } = props;

  return (
    <div className="flex flex-col p-4 space-y-2">
      <div className="space-y-2">
        {tags}
        {showTags && (
          <StatusTags project={project} />
        )}
        <div
          className={classNames(
            'space-y-1 pr-10',
            onClick && 'cursor-pointer hover:text-cs-gray-500'
          )}
          onClick={onClick ? () => onClick(project) : undefined}
        >
          {showTitle && (
            <Title project={project} />
          )}
          {showDescription && (
            <Description project={project} />
          )}
        </div>
      </div>
      <div className="flex justify-between flex-wrap gap-x-4 gap-y-2">
        <div className="flex flex-wrap gap-x-4 gap-y-2">
          {showDateRange && (
            <DateRange project={project}/>
          )}
          {showCreator && (
            <Creator project={project}/>
          )}
          {showSite && (
            <Site project={project}/>
          )}
        </div>
        {showPartners && (
          <Partners project={project}/>
        )}
        {showDistance && (
          <Distance project={project}/>
        )}
      </div>
    </div>
  );
}
